import { ThemeParameters, RuntimeThemeParameters } from '../../types';
import { graphDefault, graphNodeLabel, graphDataText } from './';

export const graphNodeDetails = (theme: ThemeParameters, parameters: RuntimeThemeParameters) => {
  return {
    textColor: graphNodeLabel(theme, parameters).textColor,
    fontFamily: graphNodeLabel(theme, parameters).fontFamily,
    fontSize: graphDefault(theme, parameters).fontSize.xxxs,
    fontStyle: graphDataText(theme, parameters).fontStyle,
    fontWeight: graphDataText(theme, parameters).fontWeight,
  };
};
